import ServerCookie from 'cookie';
/**
 * Filters cookie header string to allow whitelisted cookies and remove extraneous
 * entries.  This can be useful to avoid passing the entire cookie string in server requests
 * to One Graph which cause 413 errors when the string is too long.
 * @param cookieString cookie header string from a http request
 * @param whitelist names of allowed cookies
 */
export var filterCookieHeader = function filterCookieHeader() {
  var cookieString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var whitelist = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (!cookieString) return '';
  var cookieMap = ServerCookie.parse(cookieString);
  return whitelist.map(function (cookieName) {
    return cookieMap[cookieName] ? "".concat(cookieName, "=").concat(cookieMap[cookieName]) : null;
  }).filter(Boolean).join('; ');
};
export default filterCookieHeader;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/utils/dist/esm/cookies/filterCookieHeader.js
// module id = 2628
// module chunks = 11